var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "mentor_request base"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "dd_l" };
const _hoisted_6 = { class: "email-display" };
const _hoisted_7 = {
    key: 0,
    class: "must"
};
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { class: "f_pass w60" };
const _hoisted_10 = {
    key: 0,
    class: "err"
};
const _hoisted_11 = {
    key: 2,
    class: "must"
};
const _hoisted_12 = { key: 3 };
const _hoisted_13 = { class: "f_pass w60" };
const _hoisted_14 = {
    key: 0,
    class: "err"
};
const _hoisted_15 = {
    for: "is_notification_receiving",
    class: "checkbox01 check_box"
};
const _hoisted_16 = {
    key: 0,
    class: "err"
};
const _hoisted_17 = {
    key: 4,
    class: "must"
};
const _hoisted_18 = { key: 5 };
const _hoisted_19 = {
    key: 0,
    class: "err"
};
const _hoisted_20 = {
    key: 0,
    class: "err"
};
const _hoisted_21 = {
    key: 0,
    class: "err"
};
const _hoisted_22 = {
    key: 0,
    class: "err"
};
const _hoisted_23 = {
    key: 0,
    class: "err"
};
const _hoisted_24 = ["value"];
const _hoisted_25 = {
    key: 1,
    class: "err"
};
const _hoisted_26 = {
    key: 2,
    class: "err"
};
const _hoisted_27 = {
    key: 3,
    class: "err"
};
const _hoisted_28 = {
    key: 6,
    class: "must"
};
const _hoisted_29 = { key: 7 };
const _hoisted_30 = { class: "sel_wrapper" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = ["value"];
const _hoisted_33 = {
    key: 0,
    class: "err"
};
const _hoisted_34 = { class: "bt_box" };
const _hoisted_35 = {
    key: 0,
    class: "err_list"
};
import { ref, reactive, watch, onBeforeMount, onMounted, onUnmounted, nextTick } from 'vue';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import SearchPostalCode from '@util/SearchPostalCode';
import JobsModal from '@component/Modals/JobModal.vue';
import { isObjEmpty } from '@util/Common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'mentor_request_base',
    props: {
        common: {},
        errors: {},
        email: {},
        savedData: {}
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        const props = __props;
        const validate = reactive({ shot: false });
        // セッションに保存されたデータがあれば復元（戻るボタン対応）
        const saved = (_a = props.savedData) !== null && _a !== void 0 ? _a : {};
        const hasSavedData = Object.keys(saved).length > 0;
        const form = InertiaUtil.getForm({
            // user_id: props?.common['auth.user']?.id ?? null,
            name: (_d = (_b = saved.name) !== null && _b !== void 0 ? _b : (_c = props === null || props === void 0 ? void 0 : props.common['auth.user']) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
            email: (_e = props.email) !== null && _e !== void 0 ? _e : '',
            password: '',
            password_confirmation: '',
            real_name: (_f = saved.real_name) !== null && _f !== void 0 ? _f : '',
            kana_name: (_g = saved.kana_name) !== null && _g !== void 0 ? _g : '',
            tel: (_h = saved.tel) !== null && _h !== void 0 ? _h : '',
            postal_code: (_j = saved.postal_code) !== null && _j !== void 0 ? _j : '',
            prefecture_id: (_k = saved.prefecture_id) !== null && _k !== void 0 ? _k : null,
            city: (_l = saved.city) !== null && _l !== void 0 ? _l : '',
            building: (_m = saved.building) !== null && _m !== void 0 ? _m : '',
            industry_id: (_q = (_o = saved.industry_id) !== null && _o !== void 0 ? _o : (_p = props === null || props === void 0 ? void 0 : props.common['auth.user']) === null || _p === void 0 ? void 0 : _p.industry_id) !== null && _q !== void 0 ? _q : null,
            // 「その他」選択時はjob_id/job_group_idがnullなので、savedDataがある場合はそれを優先
            job_id: hasSavedData ? ((_r = saved.job_id) !== null && _r !== void 0 ? _r : null) : ((_t = (_s = props === null || props === void 0 ? void 0 : props.common['auth.user']) === null || _s === void 0 ? void 0 : _s.job_id) !== null && _t !== void 0 ? _t : null),
            job_group_id: hasSavedData ? ((_u = saved.job_group_id) !== null && _u !== void 0 ? _u : null) : ((_w = (_v = props === null || props === void 0 ? void 0 : props.common['auth.user']) === null || _v === void 0 ? void 0 : _v.job_group_id) !== null && _w !== void 0 ? _w : null),
            other_job_name: (_x = saved.other_job_name) !== null && _x !== void 0 ? _x : '',
            is_notification_receiving: (_y = saved.is_notification_receiving) !== null && _y !== void 0 ? _y : false,
        }, props.common.path);
        const tempForm = reactive({
            name: form.name,
            email: form.email,
            password: '',
            password_confirmation: '',
            real_name: form.real_name,
            kana_name: form.kana_name,
            tel: form.tel,
            postal_code: form.postal_code,
            prefecture_id: form.prefecture_id,
            city: form.city,
            building: form.building,
            industry_id: form.industry_id,
            job_id: form.job_id,
            job_group_id: form.job_group_id,
            other_job_name: form.other_job_name,
            is_notification_receiving: form.is_notification_receiving,
        });
        const prefOptions = ref([]);
        const industryOptions = ref([]);
        const jobOptions = ref([]);
        watch(() => tempForm.tel, () => {
            const pattern = /[^0-9-]/g;
            tempForm.tel = tempForm.tel.replace(pattern, '');
        });
        watch(() => tempForm.postal_code, () => {
            const pattern = /[^0-9-]/g;
            tempForm.postal_code = tempForm.postal_code.replace(pattern, '');
        });
        // 文字数チェック
        watch(() => tempForm.name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.password, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.password = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.password_confirmation, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.password_confirmation = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.real_name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.real_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.kana_name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.kana_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.city, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.city = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.building, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.building = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => tempForm, () => PageExitConfirm.addEvent(), { deep: true });
        const onSelectedJob = (job) => {
            var _a;
            tempForm.job_group_id = job.job_group_id;
            tempForm.job_id = job.job_id;
            tempForm.other_job_name = (_a = job.other_job_name) !== null && _a !== void 0 ? _a : '';
        };
        const onSubmit = () => {
            form.name = tempForm.name;
            form.email = tempForm.email;
            form.password = tempForm.password;
            form.password_confirmation = tempForm.password_confirmation;
            form.real_name = tempForm.real_name;
            form.kana_name = tempForm.kana_name;
            form.tel = tempForm.tel;
            form.postal_code = tempForm.postal_code;
            form.prefecture_id = tempForm.prefecture_id;
            form.city = tempForm.city;
            form.building = tempForm.building;
            form.industry_id = tempForm.industry_id;
            form.job_id = tempForm.job_id;
            form.job_group_id = tempForm.job_group_id;
            form.other_job_name = tempForm.other_job_name;
            form.is_notification_receiving = tempForm.is_notification_receiving;
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('mentor.register.verify_basic'), () => { validate.shot = true; });
        };
        const searchPostalCode = () => {
            SearchPostalCode(tempForm.postal_code, (value) => {
                var _a, _b, _c, _d;
                tempForm.prefecture_id = (_a = value === null || value === void 0 ? void 0 : value.region_id) !== null && _a !== void 0 ? _a : '';
                tempForm.city = `${(_b = value === null || value === void 0 ? void 0 : value.locality) !== null && _b !== void 0 ? _b : ''}${(_c = value === null || value === void 0 ? void 0 : value.street) !== null && _c !== void 0 ? _c : ''}`;
                tempForm.building = (_d = value === null || value === void 0 ? void 0 : value.extended) !== null && _d !== void 0 ? _d : '';
            });
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            try {
                const [prefectures, industries, jobs] = yield Promise.all([
                    axios.get('/prefectures').then(res => res.data).catch(e => {
                        console.error('Failed to load prefectures:', e);
                        return [];
                    }),
                    axios.get('/industries').then(res => res.data).catch(e => {
                        console.error('Failed to load industries:', e);
                        return [];
                    }),
                    axios.get('/jobs').then(res => res.data).catch(e => {
                        console.error('Failed to load jobs:', e);
                        return [];
                    }),
                ]);
                prefOptions.value = prefectures;
                industryOptions.value = industries;
                jobOptions.value = jobs;
                console.log('Loaded data:', { prefectures, industries, jobs });
            }
            catch (error) {
                console.error('Error in onBeforeMount:', error);
            }
        }));
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
            nextTick(() => {
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[38] || (_cache[38] = _createElementVNode("h2", null, "メンター申請（基本入力）", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[37] || (_cache[37] = _createStaticVNode("<ul class=\"step_4\"><li class=\"active\">基本入力<i class=\"fas fa-caret-up step-triangle\"></i></li><li class=\"off\">経歴入力</li><li class=\"off\">審査問い</li><li class=\"off\">完了</li></ul><p class=\"lead\"> メンターをご希望の場合、次の情報を入力頂いた後、ShareMentors事務局にて審査を行います。<br> なお、非会員の場合、メンターのご申請と同時にフリー会員として登録されます。<br> 審査結果はメールにてご連絡します。約１週間程お待ちください。<br> 結果理由につきましてはお答えいたしかねます。予めご了承下さいますようお願い致します。<br><span class=\"att\">※審査の判定基準となりますので、できるだけ具体的にご記入ください。</span></p>", 2)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"]),
                                    class: "h-adr"
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[29] || (_cache[29] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode("メール"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", _hoisted_5, [
                                            _createElementVNode("span", _hoisted_6, _toDisplayString(props.email), 1)
                                        ]),
                                        (((_a = props === null || props === void 0 ? void 0 : props.common) === null || _a === void 0 ? void 0 : _a.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dt", _hoisted_7, _cache[12] || (_cache[12] = [
                                                _createTextVNode(" パスワード"),
                                                _createElementVNode("br", { class: "pc" }, null, -1),
                                                _createElementVNode("span", { class: "must" }, "必須", -1),
                                                _createElementVNode("span", { class: "non_public" }, "非公開", -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (((_b = props === null || props === void 0 ? void 0 : props.common) === null || _b === void 0 ? void 0 : _b.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dd", _hoisted_8, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tempForm.password) = $event)),
                                                        class: "wmax",
                                                        type: "password",
                                                        id: "textPassword_1",
                                                        placeholder: "半角英数字12文字以上",
                                                        autocomplete: "new-password",
                                                        autofocus: ""
                                                    }, null, 512), [
                                                        [_vModelText, tempForm.password]
                                                    ]),
                                                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                                                        id: "buttonEye_1",
                                                        class: "fa fa-eye",
                                                        onclick: "pushHideButton(1)"
                                                    }, null, -1))
                                                ]),
                                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "allert" }, "※半角英数字12文字以上", -1)),
                                                (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.password))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(props.errors.password), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (((_d = props === null || props === void 0 ? void 0 : props.common) === null || _d === void 0 ? void 0 : _d.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dt", _hoisted_11, _cache[15] || (_cache[15] = [
                                                _createTextVNode(" 確認用パスワード"),
                                                _createElementVNode("br", { class: "pc" }, null, -1),
                                                _createElementVNode("span", { class: "must" }, "必須", -1),
                                                _createElementVNode("span", { class: "non_public" }, "非公開", -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (((_e = props === null || props === void 0 ? void 0 : props.common) === null || _e === void 0 ? void 0 : _e.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dd", _hoisted_12, [
                                                _createElementVNode("div", _hoisted_13, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((tempForm.password_confirmation) = $event)),
                                                        class: "wmax",
                                                        type: "password",
                                                        id: "textPassword_2",
                                                        placeholder: "再パスワードを入力"
                                                    }, null, 512), [
                                                        [_vModelText, tempForm.password_confirmation]
                                                    ]),
                                                    _cache[16] || (_cache[16] = _createElementVNode("span", {
                                                        id: "buttonEye_2",
                                                        class: "fa fa-eye",
                                                        onclick: "pushHideButton(2)"
                                                    }, null, -1))
                                                ]),
                                                (validate.shot && ((_f = props.errors) === null || _f === void 0 ? void 0 : _f.password_confirmation))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(props.errors.password_confirmation), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _cache[30] || (_cache[30] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 推薦状の有無"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "optionally" }, "任意"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("label", _hoisted_15, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "1",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((tempForm.is_notification_receiving) = $event)),
                                                    type: "checkbox",
                                                    id: "is_notification_receiving"
                                                }, null, 512), [
                                                    [_vModelCheckbox, tempForm.is_notification_receiving]
                                                ]),
                                                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "check_inner" }, "運営側から推薦を受けて申請します", -1))
                                            ]),
                                            (validate.shot && ((_g = props.errors) === null || _g === void 0 ? void 0 : _g.is_notification_receiving))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(props.errors.is_notification_receiving), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (((_h = props === null || props === void 0 ? void 0 : props.common) === null || _h === void 0 ? void 0 : _h.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dt", _hoisted_17, _cache[18] || (_cache[18] = [
                                                _createTextVNode(" 表示名"),
                                                _createElementVNode("br", { class: "pc" }, null, -1),
                                                _createElementVNode("span", { class: "must" }, "必須", -1),
                                                _createElementVNode("span", { class: "public" }, "公開", -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (((_j = props === null || props === void 0 ? void 0 : props.common) === null || _j === void 0 ? void 0 : _j.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dd", _hoisted_18, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((tempForm.name) = $event)),
                                                    class: "w40",
                                                    type: "text",
                                                    placeholder: "例：山田 太郎",
                                                    autocomplete: "off"
                                                }, null, 512), [
                                                    [_vModelText, tempForm.name]
                                                ]),
                                                (validate.shot && ((_k = props.errors) === null || _k === void 0 ? void 0 : _k.name))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(props.errors.name), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _cache[31] || (_cache[31] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 氏名（本名）"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((tempForm.real_name) = $event)),
                                                class: "w40",
                                                type: "text",
                                                placeholder: "例：山田 太郎"
                                            }, null, 512), [
                                                [_vModelText, tempForm.real_name]
                                            ]),
                                            (validate.shot && ((_l = props.errors) === null || _l === void 0 ? void 0 : _l.real_name))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(props.errors.real_name), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[32] || (_cache[32] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 氏名（カナ）"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((tempForm.kana_name) = $event)),
                                                class: "w40",
                                                type: "text",
                                                placeholder: "例：ヤマダ タロウ"
                                            }, null, 512), [
                                                [_vModelText, tempForm.kana_name]
                                            ]),
                                            (validate.shot && ((_m = props.errors) === null || _m === void 0 ? void 0 : _m.kana_name))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(props.errors.kana_name), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[33] || (_cache[33] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 連絡先ＴＥＬ"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _cache[19] || (_cache[19] = _createElementVNode("span", {
                                                class: "p-country-name",
                                                style: { "display": "none" }
                                            }, "Japan", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((tempForm.tel) = $event)),
                                                class: "w40",
                                                type: "text",
                                                placeholder: "例：092-000-0000",
                                                maxlength: "13"
                                            }, null, 512), [
                                                [_vModelText, tempForm.tel]
                                            ]),
                                            (validate.shot && ((_o = props.errors) === null || _o === void 0 ? void 0 : _o.tel))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(props.errors.tel), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[34] || (_cache[34] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 連絡先住所"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "sub_t nobr" }, "〒", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((tempForm.postal_code) = $event)),
                                                minlength: "7",
                                                maxlength: "8",
                                                pattern: "\\d{3}-?\\d{4}",
                                                autocomplete: "shipping postal-code",
                                                type: "text",
                                                name: "zip",
                                                onKeyUp: "AjaxZip3.zip2addr(this,'','address1','address2');",
                                                class: "w30",
                                                onInput: searchPostalCode
                                            }, null, 544), [
                                                [_vModelText, tempForm.postal_code]
                                            ]),
                                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "allert" }, "※ハイフンなしの7桁、またはハイフンありの8桁", -1)),
                                            (validate.shot && ((_p = props.errors) === null || _p === void 0 ? void 0 : _p.postal_code))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(props.errors.postal_code), 1))
                                                : _createCommentVNode("", true),
                                            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "sub_t" }, "都道府県", -1)),
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((tempForm.prefecture_id) = $event)),
                                                name: "address1",
                                                class: "w30 p-region"
                                            }, [
                                                _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, null, -1)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prefOptions.value, (pref) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: pref.id
                                                    }, _toDisplayString(pref.name), 9, _hoisted_24));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, tempForm.prefecture_id]
                                            ]),
                                            (validate.shot && ((_q = props.errors) === null || _q === void 0 ? void 0 : _q.prefecture_id))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(props.errors.prefecture_id), 1))
                                                : _createCommentVNode("", true),
                                            _cache[24] || (_cache[24] = _createElementVNode("p", { class: "sub_t" }, "市区町村・番地", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((tempForm.city) = $event)),
                                                type: "text",
                                                name: "address2",
                                                class: "wmax"
                                            }, null, 512), [
                                                [_vModelText, tempForm.city]
                                            ]),
                                            (validate.shot && ((_r = props.errors) === null || _r === void 0 ? void 0 : _r.city))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(props.errors.city), 1))
                                                : _createCommentVNode("", true),
                                            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "sub_t" }, "建物名等", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((tempForm.building) = $event)),
                                                type: "text",
                                                class: "wmax",
                                                placeholder: "例：山田ビル 101"
                                            }, null, 512), [
                                                [_vModelText, tempForm.building]
                                            ]),
                                            (validate.shot && ((_s = props.errors) === null || _s === void 0 ? void 0 : _s.building))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(props.errors.building), 1))
                                                : _createCommentVNode("", true),
                                            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "sub_t" }, null, -1))
                                        ]),
                                        (((_t = props === null || props === void 0 ? void 0 : props.common) === null || _t === void 0 ? void 0 : _t.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dt", _hoisted_28, _cache[27] || (_cache[27] = [
                                                _createTextVNode(" 業種"),
                                                _createElementVNode("br", { class: "pc" }, null, -1),
                                                _createElementVNode("span", { class: "must" }, "必須", -1),
                                                _createElementVNode("span", { class: "public" }, "公開", -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (((_u = props === null || props === void 0 ? void 0 : props.common) === null || _u === void 0 ? void 0 : _u.user_id) == null)
                                            ? (_openBlock(), _createElementBlock("dd", _hoisted_29, [
                                                _createElementVNode("div", _hoisted_30, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((tempForm.industry_id) = $event)),
                                                        id: "sel",
                                                        class: "w40",
                                                        disabled: !(((_v = props === null || props === void 0 ? void 0 : props.common) === null || _v === void 0 ? void 0 : _v.user_id) == null)
                                                    }, [
                                                        _cache[28] || (_cache[28] = _createElementVNode("option", { value: "" }, null, -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryOptions.value, (industry) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: industry.id
                                                            }, _toDisplayString(industry.name), 9, _hoisted_32));
                                                        }), 256))
                                                    ], 8, _hoisted_31), [
                                                        [_vModelSelect, tempForm.industry_id]
                                                    ])
                                                ]),
                                                (validate.shot && ((_w = props.errors) === null || _w === void 0 ? void 0 : _w.industry_id))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(props.errors.industry_id), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _cache[35] || (_cache[35] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 職種"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "public" }, "公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _createVNode(JobsModal, {
                                                options: jobOptions.value,
                                                form: tempForm,
                                                errors: props.errors,
                                                "validate-shot": validate.shot,
                                                onSelected: onSelectedJob
                                            }, null, 8, ["options", "form", "errors", "validate-shot"])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                        (validate.shot)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                    return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                                }), 256))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _cache[36] || (_cache[36] = _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    id: "submit-button",
                                                    value: "次へ"
                                                }, "次へ")
                                            ])
                                        ], -1))
                                    ])
                                ], 32)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
